export default [{
    path: '/account/questions/', name: 'account.question', component: () => import('./Question.vue'), meta: {title: 'Questions', authenticate: true},
    children: [
        {
            path: '', name: 'account.question.index', component: () => import('./page/QuestionDetailPage.vue'),
            props: (route) => ({
                page: route.query.page,
                limit: route.query.limit,
                search: route.query.search,
                searchType: route.query.searchType,
                sortby: route.query.sortby,
                sortdirection: route.query.sortdirection
            }), meta: {authenticate: true}
        },
        { path: 'new/', name: 'account.question.create', component: () => import('./page/QuestionCreatePage.vue'), meta: {authenticate: true}},
        { path: ':questionId/', name: 'account.question.edit', component: ()=> import('./page/QuestionEditPage.vue'), meta: {authenticate: true } }
    ]
}]